import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import KycContent from './KycContent';
import { KycCheckReturnType } from '~/hooks/kyc';
import setKycModalOpen from './setKycModalOpen';

interface Props {
  open?: boolean;
  onClose?: () => void;
  kycCheck: KycCheckReturnType;
}

const KycModal = (props: Props): JSX.Element => {
  const { open, onClose, kycCheck } = props;
  const [t] = useTranslation('kyc');

  return (
    <Modal
      visible={open}
      onCancel={onClose}
      title={kycCheck.isPending ? t('Please, wait') : t('Permission denied')}
      footer={null}
      centered
    >
      <KycContent onClose={onClose} {...kycCheck} />
    </Modal>
  );
};

KycModal.setOpen = setKycModalOpen;

export default KycModal;
